import React, { createRef, useRef } from "react";
import { useParams } from "react-router";
import { Formik } from "formik";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Typography from "@mui/material/Typography";
import Backdrop from "@mui/material/Backdrop";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

import { CaptureProvider } from "../../../../contexts/capture";
import { fetchAssetValues } from "../../../../utils/asset";
import { useAssetsCollection } from "../../../../contexts/assetsCollection";
import FormPage from "../../../../components/TablePro/components/assets/FormPage";
import { useEditAsset } from "../../../../components/TablePro/Table/EditAssetProvider";
import useAuth from "../../../../hooks/useAuth";
import useUnsavedChanges from "../../../../hooks/useUnsavedChanges";
import UnsavedChangesDialog from "../../../../components/modals/UnsavedChanges/UnsavedChangesDialog";

const DisableTransitionComponent = ({ children }) => children;

export default function AssetDetailsModal({ entity, onClose }) {
  const { user } = useAuth();
  const { settings } = user.company;
  const warehouseDropdownEnabled = settings.warehouse_id_dropdown_menu;
  const { handeRefetch } = useAssetsCollection();
  const { setAsset } = useEditAsset();
  const { clientId } = useParams();
  const nav = window.location.pathname.split("/")[1];
  const displayClient = !warehouseDropdownEnabled && nav === "clients" && clientId === "null";
  const displayProject = nav === "clients";
  const displayWarehouse = warehouseDropdownEnabled;

  const formikRef = createRef();
  const saveHandlerRef = useRef(null);
  const {
    attemptClose,
    confirmDiscard,
    cancelDiscard,
    confirmSave,
    showDialog,
    saving,
  } = useUnsavedChanges({
    onClose,
    isDirtyFn: () => !!formikRef.current?.dirty,
    onSave: async () => {
      await saveHandlerRef.current();
    },
  });

  const openDuplicatedAsset = asset => {
    attemptClose();
    setAsset(asset);
  };

  return (
    <>
      <Dialog
        open
        fullWidth
        maxWidth={false}
        onClose={attemptClose}
        TransitionComponent={DisableTransitionComponent}
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            sx: {
              transition: "none !important",
            },
          },
        }}
        sx={{
          "& .MuiDialog-paper": {
            maxWidth: "1000px",
            width: "100%",
          },
        }}
      >
        <DialogTitle
          sx={{ background: "#f4f6f8", display: "flex", justifyContent: "space-between" }}
        >
          <Box width="48px" />
          <Typography fontSize={24} fontWeight={500} color="textPrimary">
            Item Details
          </Typography>
          <IconButton onClick={attemptClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ background: "#f4f6f8" }}>
          <Box>
            <CaptureProvider>
              <Formik
                innerRef={formikRef}
                key={entity?.id}
                initialValues={fetchAssetValues(entity)}
                onSubmit={() => {}}
              >
                <FormPage
                  type="scrubber"
                  displayClient={displayClient}
                  displayProject={displayProject}
                  displayWarehouse={displayWarehouse}
                  currentAsset={entity}
                  onCloseModal={onClose}
                  handeRefetch={handeRefetch}
                  openDuplicatedAsset={openDuplicatedAsset}
                  registerSaveHandler={fn => {
                    saveHandlerRef.current = fn;
                  }}
                />
              </Formik>
            </CaptureProvider>
          </Box>
        </DialogContent>
      </Dialog>
      {showDialog && (
        <UnsavedChangesDialog
          open={showDialog}
          onCancel={cancelDiscard}
          onDiscard={confirmDiscard}
          onSave={confirmSave}
          saving={saving}
        />
      )}
    </>
  );
}
